import { Link } from "react-router-dom";
import { Check, ArrowUpRight } from "lucide-react";

const ITEMS = ["Source code", "Application credentials", "Deployment credentials", "Project assets", "Relevant documentation"];

export default function Ownership() {
  return (
    <section className="py-24 lg:py-36 border-t border-white/5" data-testid="ownership-section">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <div>
            <p className="section-label">CLIENT OWNERSHIP</p>
            <h2 className="mt-5 font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-white">
              YOUR SOFTWARE.<br /><span className="text-flame">YOUR CODE.</span>
            </h2>
            <p className="mt-6 text-slate-400 leading-relaxed max-w-lg">
              No hostage situations. Subject to the project agreement, handover includes everything you need to own,
              run and evolve your application.
            </p>
            <Link
              to="/legal#ownership"
              data-testid="ownership-terms-link"
              className="mt-8 inline-flex items-center gap-2 text-sm font-heading font-bold text-flame hover:gap-3 transition-all"
            >
              VIEW OWNERSHIP TERMS <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
          <div className="rounded-2xl border border-white/10 bg-navy-800 p-8 sm:p-10">
            <p className="font-mono text-[11px] tracking-[0.25em] text-slate-500 mb-8">HANDOVER INCLUDES</p>
            <ul className="space-y-5">
              {ITEMS.map((i) => (
                <li key={i} className="flex items-center gap-4">
                  <span className="w-8 h-8 rounded-full bg-flame/15 border border-flame/40 flex items-center justify-center shrink-0">
                    <Check className="w-4 h-4 text-flame" />
                  </span>
                  <span className="font-heading font-semibold text-slate-100">{i}</span>
                </li>
              ))}
            </ul>
            <p className="mt-8 text-[11px] text-slate-600 leading-relaxed">
              Ownership and usage rights are governed by the signed project agreement. Final legal documents should be
              reviewed by qualified legal counsel.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
